module.exports = __webpack_public_path__ + "img/9.71eac46.svg";